<script lang="ts" setup>
import PartnershipsItems from '@/domains/esg/partnerships/components/partnerships/PartnershipsItems.vue'
import { usePartnerships } from '@/domains/esg/composables/content/usePartnerships'

const { partnershipItems } = usePartnerships()
</script>

<template>
  <UiSection
    id="partnerships"
    class="partnerships"
    color="gray"
  >
    <div class="section__container">
      <div class="section__row">
        <div class="section__col">
          <UiHeader
            :header="$t('partnerships.partnerships.header')"
            :subheader="$t('partnerships.partnerships.subheader')"
            :position="'center'"
          />

          <PartnershipsItems :items="partnershipItems" />
        </div>
      </div>
    </div>
  </UiSection>
</template>

<style lang="scss" scoped>
.partnerships {
  padding-top: 3.2rem;
  padding-bottom: 3.2rem;

  @include atM {
    padding-top: 12rem;
    padding-bottom: 12rem;
  }
}
</style>
